import React from "react";

const FinalSettle = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M21.2 2H2v25.6h6.4V34H34V14.8H21.2V2Zm9.6 28.8H11.6v-3.2h9.6V18h9.6v12.8Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M24.4 2v3.2c3.529 0 6.4 2.871 6.4 6.4H34C34 6.307 29.693 2 24.4 2Z"
            fill={fill}
        />
    </svg>
);

export default FinalSettle;
